/**
* @ngdoc directive
* @name moduleDispatch.directive:myDispatchForm
* @restrict 'E'
* @element ANY
* @priority 0
* @scope
* @param {object} myDispatch The object representing a dispatch element
* @param {string} myId An id for the handle of input fields
*
* @description A bundle of all input fields required for instantiate a new dispatch
*
* @example
<example module="moduleDispatch">
<file name="index.html">
<my-dispatch-create-inputs my-dispatch="dispatch" my-id="'id'">
</my-dispatch-create-inputs>
<pre>{{dispatch}}</pre>
</file>
</example>
**/

/* @ngInject */
const myDispatchForm = () => {
  return {
    restrict: 'E',
    scope: {
      myDispatch: '=',
      enableValidator: '=?',
    },
    template: require('./myDispatchForm.html'),

    /* @ngInject */
    controller: ($scope, $$dispatch) => {
      $scope.fieldsOptions = $$dispatch.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDispatchForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/directives/forms/myDispatchForm.js